// Tracking + Google Consent Mode v2 helpers
// IDs actifs (voir public/index.html) : Google Ads AW-16850138467, GA4 G-LMCW0Z9G78, Meta Pixel 2088175772055116.
import { log } from "@/lib/log";

const GOOGLE_ADS_ID = "AW-16850138467";
export const CONSENT_KEY = "aetheris_consent_v1";

function gtagEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

function fbqTrack(name, params = {}, eventID) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  try {
    const ids = Array.isArray(window.AETHERIS_PIXEL_IDS) && window.AETHERIS_PIXEL_IDS.length
      ? window.AETHERIS_PIXEL_IDS
      : null;
    const opts = eventID ? { eventID } : undefined;
    if (ids) {
      // Multi-pixel: garantit que CHAQUE pixel reçoit l'événement (fbq('track', ...) fire seulement sur le 1er)
      // eventID (options) est utilisé par Meta pour dédupliquer avec l'événement CAPI côté serveur.
      ids.forEach((id) => {
        if (opts) window.fbq("trackSingle", id, name, params, opts);
        else window.fbq("trackSingle", id, name, params);
      });
    } else {
      if (opts) window.fbq("track", name, params, opts);
      else window.fbq("track", name, params);
    }
  } catch (e) {
    log.warn("[tracking] pixel non initialisé :", e);
  }
}

// --------- Événements de conversion ---------
export function trackInitiateCheckout({ value = 0, currency = "EUR", packageId } = {}) {
  gtagEvent("begin_checkout", {
    currency,
    value,
    items: packageId ? [{ item_id: packageId }] : [],
  });
  // Note: pas de conversion Google Ads ici tant qu'un libellé InitiateCheckout
  // n'est pas fourni (éviter un double comptage sur le compte AW-16850138467).
  fbqTrack("InitiateCheckout", { value, currency });
}

export function trackPurchase({ value = 0, currency = "EUR", transactionId, packageId } = {}) {
  // Google Ads — conversion d'achat
  gtagEvent("conversion", {
    send_to: `${GOOGLE_ADS_ID}/purchase`,
    value,
    currency,
    transaction_id: transactionId,
  });
  // GA4 — achat
  gtagEvent("purchase", {
    transaction_id: transactionId,
    value,
    currency,
    items: packageId ? [{ item_id: packageId }] : [],
  });
  // Meta Pixel — achat
  fbqTrack("Purchase", { value, currency });
}

export function trackPageView(path) {
  gtagEvent("page_view", { page_path: path });
  fbqTrack("PageView");
}

// Meta Pixel — Lead (soumission formulaire de capture)
// Note: 'Lead' est un événement standard Meta, se déclenche sur TOUS les pixels initialisés.
// eventID (optionnel) permet la déduplication avec l'événement CAPI côté serveur.
export function trackLead({ value = 0, currency = "EUR", content_name, eventID } = {}) {
  fbqTrack("Lead", { value, currency, content_name }, eventID);
  // GA4 — event miroir pour la cohérence funnel
  gtagEvent("generate_lead", { value, currency });
}

// Meta Pixel — CompleteRegistration (fin de questionnaire pré-diagnostic)
export function trackCompleteRegistration({ value = 0, currency = "EUR", content_name, eventID } = {}) {
  fbqTrack("CompleteRegistration", { value, currency, content_name }, eventID);
  gtagEvent("sign_up", { value, currency });
}

// --------- Google Consent Mode v2 (mise à jour dynamique) ---------
export function applyConsent({ analytics = false, ads = false }) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: ads ? "granted" : "denied",
      ad_user_data: ads ? "granted" : "denied",
      ad_personalization: ads ? "granted" : "denied",
    });
  }
}

// Stocke uniquement le CHOIX de consentement cookies (aucune donnée personnelle ni token).
export function storeConsent(consent) {
  const value = { ...consent, ts: Date.now() };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  } catch (e) {
    log.warn("[tracking] consentement non persisté :", e);
  }
  applyConsent(consent);
}

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    log.warn("[tracking] lecture consentement impossible :", e);
    return null;
  }
}
